// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../common/temp/node_modules/.pnpm/@rsbuild+core@1.1.14/node_modules/@rsbuild/core/compiled/css-loader/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../common/temp/node_modules/.pnpm/@rsbuild+core@1.1.14/node_modules/@rsbuild/core/compiled/css-loader/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.topBar-wk41GG{flex-direction:column;width:100%;display:flex}.topBar-wk41GG .des-HkH2tz{align-items:center;margin:0;font-size:14px;font-style:normal;font-weight:600;display:flex}.topBar-wk41GG .tabs-zci4Ti{text-align:left;width:100%}.topBar-wk41GG .name-BfdvcC{word-break:break-word;max-width:calc(100% - 28px);height:28px;color:rgba(var(--coze-fg-4),var(--coze-fg-4-alpha));font-size:20px;font-style:normal;font-weight:500;line-height:28px}.topBar-wk41GG .split-LkFWjP{background-color:var(--coz-stroke-primary);border-bottom:none;width:1px;height:20px;margin:0 4px}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"topBar": `topBar-wk41GG`,
	"des": `des-HkH2tz`,
	"tabs": `tabs-zci4Ti`,
	"name": `name-BfdvcC`,
	"split": `split-LkFWjP`
};
export default ___CSS_LOADER_EXPORT___;
